<template>
  <div class="provisioning-loading-container" :class="{ 'unShow': !status}">
    <div class="loading-wrap">
      <a-spin class="loading-spin-box">
        <a-icon #indicator type="loading" class="loading-icon" style="color: #C0E560"/>
        <div class="ant-spin-text">
          {{text}}
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProvisioningLoading',
  props: {
    status: Boolean,
    text: String,
  },
}
</script>